/**
 * TeleTime POS - Tax API
 */

import api from './axios';

/**
 * The server's per-unit EHF for each line, in cents (POST /api/tax/ehf/resolve). The same
 * resolver the recorder charges with, so the till tenders the total the recorder expects.
 *
 * Never throws: a failure comes back as `{ success: false }` and the caller holds tender
 * rather than guess (see tenderGate).
 *
 * @param {Array<{productId:number, name?:string, sku?:string}>} lines
 * @param {string} province
 * @returns {Promise<{success: boolean, data?: {province: string, lines: Array<{index:number, productId:number|null, ehfCents:number}>}, error?: string}>}
 */
export const resolveEhf = async (lines, province) => {
  try {
    const response = await api.post('/tax/ehf/resolve', { province, lines });
    const result = response.data || response;
    if (result.success === false) {
      return { success: false, error: result.error || 'EHF lookup failed' };
    }
    return { success: true, data: result.data || result };
  } catch (error) {
    console.warn('[Tax] resolveEhf failed:', error.message || error);
    return { success: false, error: error.message || 'EHF lookup unavailable' };
  }
};

export default { resolveEhf };
